import {useI18n} from '@logistics-frontend/core/i18n'
import {useCallback} from 'react'

import {StrictTranslator} from './Disclaimer.types'

export const useStrictTranslator = () => {
  const t = useI18n()
  return useCallback<StrictTranslator>((key, placeholder) => t(key, {placeholder, fallBackToKey: false}), [t])
}
